// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__19qpR","meals-appear":"AvailableMeals_meals-appear__1kSa5"};